import {connect} from '../../app/connect';
import IssueRootCauseDropdown from './IssueRootCauseDropdown';
import {
  getActiveIssueRootCausesGroupedDropdownOptions,
  getIssueRootCausesDefinitionsEntitiesMap
} from '../../app/selectors';

const mapStateToProps = state => ({
  activeIssueRootCausesGroupedDropdownOptions: getActiveIssueRootCausesGroupedDropdownOptions(state),
  rootCauseEntitiesMap: getIssueRootCausesDefinitionsEntitiesMap(state)
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IssueRootCauseDropdown);
